(ns frontend.view.printouts.db
  (:require [reagent.core :as r]
            [frontend.db :as app-db]))

(defonce state (r/cursor app-db/app-state [:views :printouts :data]))
(defonce settings (r/cursor app-db/app-state [:views :printouts :settings]))
